import { render, staticRenderFns } from "./AddCompanyWiseTransactionFeeComponent.vue?vue&type=template&id=bd7b6e34&"
import script from "./AddCompanyWiseTransactionFeeComponent.vue?vue&type=script&lang=js&"
export * from "./AddCompanyWiseTransactionFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports